import useGetCountryFromUrl from './useGetCountryFromUrl';
import useShoppingCartSummaryChile from './countryShoppingCartSummaryHooks.js/useShoppingCartSummaryChile';
import useShoppingCartSummaryMexico from './countryShoppingCartSummaryHooks.js/useShoppingCartSummaryMexico';

const useShoppingCartSummary = (shoppingCartData) => {
  const country = useGetCountryFromUrl();
  const countryHooks = {
    Chile: useShoppingCartSummaryChile,
    Mexico: useShoppingCartSummaryMexico,
  };

  const selectedHook = countryHooks[country?.name] || useShoppingCartSummaryChile;
  return selectedHook(shoppingCartData);
};

export default useShoppingCartSummary;
